import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
const normalizeId = (id) => id.trim();
export const useFavouritesStore = create()(persist((set, get) => ({
    favourites: [],
    clubDetails: {},
    setAll: (ids, details) => set(() => {
        const uniqueIds = Array.from(new Set(ids
            .filter((id) => typeof id === 'string')
            .map((id) => normalizeId(id))
            .filter((id) => id.length > 0)));
        const detailMap = {};
        if (Array.isArray(details)) {
            for (const info of details) {
                const normalizedId = info?.clubId ? normalizeId(info.clubId) : '';
                if (!normalizedId) {
                    continue;
                }
                detailMap[normalizedId] = { ...info, clubId: normalizedId };
            }
        }
        return { favourites: uniqueIds, clubDetails: detailMap };
    }),
    add: (id, info) => set((state) => {
        const normalizedId = normalizeId(id);
        if (!normalizedId) {
            return state;
        }
        const favourites = state.favourites.includes(normalizedId)
            ? state.favourites
            : [...state.favourites, normalizedId];
        const nextDetails = info
            ? { ...state.clubDetails, [normalizedId]: { ...info, clubId: normalizedId } }
            : state.clubDetails;
        return { favourites, clubDetails: nextDetails };
    }),
    remove: (id) => set((state) => {
        const normalizedId = normalizeId(id);
        const { [normalizedId]: _removed, ...rest } = state.clubDetails;
        return {
            favourites: state.favourites.filter((f) => f !== normalizedId),
            clubDetails: rest,
        };
    }),
    isFavourite: (id) => get().favourites.includes(normalizeId(id)),
}), {
    name: 'favourites-storage',
    storage: typeof window === 'undefined' ? undefined : createJSONStorage(() => localStorage),
}));
//# sourceMappingURL=useFavouritesStore.js.map